import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule, CardModule, ButtonModule],
  template: `
    <div class="home-container">
      <div class="home-header">
        <h1>WeSportech Arena</h1>
        <p>Plataforma de gestión de torneos multi-deporte</p>
      </div>

      <div class="menu-cards">
        <div class="menu-card" routerLink="/events">
          <div class="card-icon">
            <i class="pi pi-calendar"></i>
          </div>
          <div class="card-content">
            <h3>Eventos</h3>
            <p>Gestiona eventos multi-disciplina</p>
          </div>
          <div class="card-arrow">
            <i class="pi pi-chevron-right"></i>
          </div>
        </div>

        <div class="menu-card" routerLink="/sports">
          <div class="card-icon">
            <i class="pi pi-star"></i>
          </div>
          <div class="card-content">
            <h3>Deportes</h3>
            <p>Catálogo de deportes y disciplinas</p>
          </div>
          <div class="card-arrow">
            <i class="pi pi-chevron-right"></i>
          </div>
        </div>

        <div class="menu-card" routerLink="/tournaments">
          <div class="card-icon">
            <i class="pi pi-trophy"></i>
          </div>
          <div class="card-content">
            <h3>Torneos</h3>
            <p>Gestiona y administra torneos deportivos</p>
          </div>
          <div class="card-arrow">
            <i class="pi pi-chevron-right"></i>
          </div>
        </div>

      </div>
    </div>
  `,
  styles: [`
    .home-container {
      padding: 2rem;
      max-width: 1200px;
      margin: 0 auto;
    }

    .home-header {
      text-align: center;
      margin-bottom: 3rem;
    }

    .home-header h1 {
      font-size: 2.5rem;
      color: #1a1a1a;
      margin-bottom: 0.5rem;
      font-weight: 700;
    }

    .home-header p {
      color: #666;
      font-size: 1.1rem;
    }

    .menu-cards {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
      gap: 1.5rem;
    }

    .menu-card {
      display: flex;
      align-items: center;
      padding: 1.5rem;
      background: white;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      cursor: pointer;
      transition: all 0.2s ease;
      border: 1px solid #e0e0e0;
    }

    .menu-card:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
      border-color: #007bff;
    }

    .card-icon {
      width: 56px;
      height: 56px;
      border-radius: 12px;
      background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 1rem;
      flex-shrink: 0;
    }

    .card-icon i {
      font-size: 1.5rem;
      color: white;
    }

    .card-content {
      flex: 1;
    }

    .card-content h3 {
      margin: 0 0 0.25rem 0;
      font-size: 1.1rem;
      font-weight: 600;
      color: #1a1a1a;
    }

    .card-content p {
      margin: 0;
      font-size: 0.875rem;
      color: #666;
    }

    .card-arrow {
      color: #ccc;
      transition: color 0.2s ease;
    }

    .menu-card:hover .card-arrow {
      color: #007bff;
    }

    @media (max-width: 768px) {
      .home-container {
        padding: 1rem;
      }

      .home-header h1 {
        font-size: 1.75rem;
      }

      .menu-cards {
        grid-template-columns: 1fr;
      }
    }
  `]
})
export class HomeComponent {}
